import React from "react";
import config from "../component/config";

const PrintHeader = ({ ecData , lab }) => {
  return (
    console.log("ecData", ecData),
    <div>
      <div id="head" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        {/* Left Section - Government Information */}
        <div>
          <p className="fw-bold">REPUBLIQUE DU CAMEROUN</p>
          <p>Paix Travail Patrie</p>
          <p className="fw-bold">MINISTERE DE L'EDUCATION DE BASE</p>
          <p>Délégation Régionale de l'Est</p>
          <p>Délégation Départementale du Lom et Djerem</p>
        </div>

        {/* Center - Logo */}
        <div>
          {ecData.logo ? (
            <img src={`${config.apiBaseUrl}/logo/${ecData.logo}`} style={{ width: "80px" }} alt="Logo" />
          ) : (
            <p className="text-muted">Logo indisponible</p>
          )}
        </div>

        {/* Right Section - Government Details */}
        <div>
          <p className="fw-bold">REPUBLIC OF CAMEROON</p>
          <p>Peace Work Fatherland</p>
          <p className="fw-bold">MINISTRY OF BASIC EDUCATION</p>
          <p>East Regional Delegation</p>
          <p>Lom and Djerem Divisional Delegation</p>
        </div>
      </div>

      {/* School Name */}
      <div id="middle" className="text-center mt-2">
        <h4 className="fw-bold">{ecData?.nomec || "Nom de l'école indisponible"}</h4>
      </div>

      {/* Page Title */}
      <h5 className="text-center mt-2">{lab}</h5>
    </div>
  );
};

export default PrintHeader;
